"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConditionalMapperNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'CONDITIONAL-MAPPER';
class ConditionalMapperNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        // We define specific resolvers here so that we don't have to resolve inputs that are never used.
        this.asynchronousResolver = async (nodeMap) => {
            const booleanValue = await this.asynchronousGetInputValue(nodeMap, this.inputReferences.booleanSource);
            if (typeof booleanValue === 'boolean') {
                return {
                    output: booleanValue
                        ? (await this.asynchronousGetInputValue(nodeMap, this.inputReferences.trueSource))
                        : (await this.asynchronousGetInputValue(nodeMap, this.inputReferences.falseSource)),
                };
            }
            return Promise.resolve({ output: undefined });
        };
        this.synchronousResolver = (nodeMap) => {
            const booleanValue = this.synchronousGetInputValue(nodeMap, this.inputReferences.booleanSource);
            if (typeof booleanValue === 'boolean') {
                return {
                    output: booleanValue
                        ? this.synchronousGetInputValue(nodeMap, this.inputReferences.trueSource)
                        : this.synchronousGetInputValue(nodeMap, this.inputReferences.falseSource),
                };
            }
            return { output: undefined };
        };
        //TODO: Build the interface definition from the given schema....but what is our schema
        this._interfaceDefinition = Schema;
    }
    get interfaceDefinition() {
        this.config.type = this.config.type || 'String';
        const InputParams = this._interfaceDefinition.definitions.InputParams;
        const OutputParams = this._interfaceDefinition.definitions.OutputParams;
        if (InputParams.properties.trueSource && InputParams.properties.falseSource && OutputParams.properties.output) {
            InputParams.properties.trueSource = BaseNode_1.BaseNode.getProp(this.config.type, 'Value if True');
            InputParams.properties.falseSource = BaseNode_1.BaseNode.getProp(this.config.type, 'Value if False');
            OutputParams.properties.output = BaseNode_1.BaseNode.getProp(this.config.type, 'Output');
        }
        return {
            InputParams: InputParams,
            OutputParams: OutputParams,
            ConfigParams: {
                type: 'object',
                properties: {
                    type: {
                        description: 'Type',
                        type: 'string',
                        enum: [
                            'Boolean',
                            'Date',
                            'GeoJSON',
                            'Number',
                            'Object',
                            'Photo',
                            'String',
                            'Boolean Array',
                            'Date Array',
                            'GeoJSON Array',
                            'Number Array',
                            'Object Array',
                            'Photo Array',
                            'String Array',
                        ],
                        default: 'String',
                    },
                },
            },
        };
    }
}
exports.ConditionalMapperNode = ConditionalMapperNode;
ConditionalMapperNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Conditional Mapper',
    isIdempotent: true,
    primaryCategory: 'Logic',
};
//# sourceMappingURL=ConditionalMapper.js.map